import {
    boolean,
    string,
    object,
    mixed,
    InferType,
    ObjectSchema,
    array,
} from "yup";

import { AccessLevelEnum } from "../contracts/criar-usuario.contract";
import { AccountBankTypeEnum, PixKeyTypeEnum } from "../../enum";
import { EditarUsuariosContract } from "../contracts/editar-usuario.contract";

export const editarUsuarioSchema: ObjectSchema<EditarUsuariosContract> = object({
    fullName: string().required("Nome do Usuário é obrigatório"),
    email: string()
        .email("Formato de e-mail inválido")
        .required("E-mail do Usuário obrigatório"),
    cpf: string().required("CPF é obrigatório"),
    contact1: string().required("Contato 1 é obrigatório"),
    contact2: string().nullable().default(null),
    active: boolean().default(true),
    avatar: string().nullable().default(null),
    /*accessLevel: array()
        .of(
            mixed<AccessLevelEnum>()
                .oneOf(Object.values(AccessLevelEnum))
                .required("Nível de acesso é obrigatório")
        )
        .min(1, "Selecione ao menos um nível de acesso")
        .required("Nível de acesso é obrigatório"),*/
});

export type EditarUsuarioFormData = InferType<typeof editarUsuarioSchema>;
